import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csinput(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# input tutorial For Beginners</title>
 <meta name="description" content="C# input tutorial for beginners.input in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# input,c# input for,csharp input,Input tutorial For Begineers" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-input" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Input Statement:
</h1>
<div className="first">
        <a href="/csharp-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-literal">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   



<h2 className='headings'>Input in C# Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-4">readline</span>
            <span className="qwerty-5">() </span>
            <span className="qwerty-3">is used to input a value in</span>
            <span className="qwerty-2"> C#. </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className='headings'>Q-write a program in C# input and print name Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-7">namespace </span>
            <span className="qwerty-3">inputc#</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty-4">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">static </span>
            <span className="qwerty-4">void</span>
            <span className="qwerty-10"> Main</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[]</span>
            <span className="qwerty"> args</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">what is your name</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">String </span>
            <span className="qwerty-3">name</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-10">ReadLine</span>
            <span className="qwerty-4">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">My name is </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">+ </span>
            <span className="qwerty">name</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">what is your name </span>
              {"\n"}
              <span className="qwerty-5">code Exampler </span>
              {"\n"}
              <span className="qwerty-6">My name is </span>
              <span className="qwerty-5">code Exampler </span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>



<h2 className='headings'>Q-write a program to input 3 numbers in C# and print the total marks?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-7">namespace </span>
            <span className="qwerty-3">inputc#</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty-4">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">static </span>
            <span className="qwerty-4">void</span>
            <span className="qwerty-10"> Main</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[]</span>
            <span className="qwerty"> args</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-5">sum</span>
            <span className="qwerty-4">;</span>
            <span className="qwerty-3"> //</span>
            <span className="qwerty-7">This declare a variable</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> first </span>
              <span className="qwerty-3">no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> second </span>
              <span className="qwerty-3">no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> third </span>
              <span className="qwerty-3">no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">c</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">sum</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty">sum</span>
            <span className="qwerty-3"> = "</span>
            <span className="qwerty-10"> + </span>
            <span className="qwerty">sum</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> first </span>
              <span className="qwerty-3">no</span>
              {"\n"}
              <span className="qwerty-5">42</span>
              {"\n"}
              <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> second </span>
              <span className="qwerty-3">no</span>
              {"\n"}
              <span className="qwerty-5">54</span>
              {"\n"}
              <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> third </span>
              <span className="qwerty-3">no</span>
              {"\n"}
              <span className="qwerty-5">65</span>
              {"\n"}
              <span className="qwerty-4">sum</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">161</span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>




<h2 className='headings'>Q-write a program to calculate and print a simple interest Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-7">namespace </span>
            <span className="qwerty-3">inputc#</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty-4">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">static </span>
            <span className="qwerty-4">void</span>
            <span className="qwerty-10"> Main</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[]</span>
            <span className="qwerty"> args</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">float </span>
            <span className="qwerty-10">p</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">r</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">t</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">SI</span>
            
            <span className="qwerty-4">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> p </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">p</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> r </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">r</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> t </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">t</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">SI</span>
  
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">p</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-10">r</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-10">t</span>
            <span className="qwerty-3"> / </span>
            <span className="qwerty-5">100</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-10">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Simple </span>
              <span className="qwerty-6">interest</span>
            <span className="qwerty-3"> = "</span>
            <span className="qwerty-10"> + </span>
            <span className="qwerty-4">SI</span>
           
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-3">enter the</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> p </span>
              {"\n"}
              <span className="qwerty-5">45</span>
              {"\n"}
              <span className="qwerty-3">enter the</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> r </span>
              {"\n"}
              <span className="qwerty-5">26</span>
              {"\n"}
              <span className="qwerty-3">enter the</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> t </span>
              {"\n"}
              <span className="qwerty-5">18</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-4">Simple </span>
              <span className="qwerty-6">interest</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">210.6 </span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to find and print the area of the rectangle in C# Input?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-7">namespace </span>
            <span className="qwerty-3">input_area</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty-4">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">static </span>
            <span className="qwerty-4">void</span>
            <span className="qwerty-10"> Main</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[]</span>
            <span className="qwerty"> args</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-10">l</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">area</span>
            <span className="qwerty-4">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter a </span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> l</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">l</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter the</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> b</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">area</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-10">l</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Area </span>
            <span className="qwerty-3"> = "</span>
            <span className="qwerty-10"> + </span>
              <span className="qwerty-4">area</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> l </span>
              {"\n"}
              <span className="qwerty-5">5</span>
              {"\n"}
              <span className="qwerty-3">enter the</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> b </span>
              {"\n"}
              <span className="qwerty-5">4</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-4">Area</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">20</span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to find out the value of the pi(3.14) and print area of circle?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">double </span>
            <span className="qwerty-10">r</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">area</span>
            <span className="qwerty-4">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter a </span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> r</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">r</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">area </span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-5">3.14</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-2">r</span>
            <span className="qwerty-5"> * </span>
            <span className="qwerty-2">r</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Area </span>
            <span className="qwerty-3"> = "</span>
            <span className="qwerty-10"> + </span>
              <span className="qwerty-4">area</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> r </span>
              {"\n"}
              <span className="qwerty-5">4</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-4">Area</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">50.24</span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>





<h2 className='headings'>Q-Write a program to 3 subject marks add all values and multiply all the values?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-7">namespace </span>
            <span className="qwerty-3">input_area</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty-4">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-7">static </span>
            <span className="qwerty-4">void</span>
            <span className="qwerty-10"> Main</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[]</span>
            <span className="qwerty"> args</span>
            <span className="qwerty-10">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">add</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-6">mult</span>
            <span className="qwerty-4">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> a </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> b </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> c </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">c</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">Convert.</span>
            <span className="qwerty-7">ToInt32 </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-3">ReadLine</span>
            <span className="qwerty-10">()</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">add</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">mult</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Addition </span>
            <span className="qwerty-3"> = "</span>
            <span className="qwerty-10"> + </span>
              <span className="qwerty-4">add</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">multiply </span>
            <span className="qwerty-3"> = "</span>
            <span className="qwerty-10"> + </span>
              <span className="qwerty-6">mult</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}
            <span className="qwerty-4">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> a </span>
              {"\n"}
              <span className="qwerty-5">2</span>
              {"\n"}
              <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> b </span>
              {"\n"}
              <span className="qwerty-5">3</span>
              {"\n"}
              <span className="qwerty-3">enter a</span>
              <span className="qwerty-4"> value </span>
              <span className="qwerty-3">of</span>
              <span className="qwerty-4"> c </span>
              {"\n"}
              <span className="qwerty-5">4</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-4">Addition</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">9</span>
              {"\n"}
              <span className="qwerty-6">multiply</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">24</span>
              {"\n"}{"\n"}
            </code></pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-literal">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csinput;